/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindLeadsBatchWithCommentCountsRequest
 */
export interface FindLeadsBatchWithCommentCountsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof FindLeadsBatchWithCommentCountsRequest
     */
    lead_ids: Array<string>;
}

/**
 * Check if a given object implements the FindLeadsBatchWithCommentCountsRequest interface.
 */
export function instanceOfFindLeadsBatchWithCommentCountsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;

    return isInstance;
}

export function FindLeadsBatchWithCommentCountsRequestFromJSON(json: any): FindLeadsBatchWithCommentCountsRequest {
    return FindLeadsBatchWithCommentCountsRequestFromJSONTyped(json, false);
}

export function FindLeadsBatchWithCommentCountsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadsBatchWithCommentCountsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
    };
}

export function FindLeadsBatchWithCommentCountsRequestToJSON(value?: FindLeadsBatchWithCommentCountsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
    };
}

